import { render, staticRenderFns } from "./sad-product-field.vue?vue&type=template&id=390d957a&scoped=true&"
import script from "./sad-product-field.vue?vue&type=script&lang=js&"
export * from "./sad-product-field.vue?vue&type=script&lang=js&"
import style0 from "./sad-product-field.vue?vue&type=style&index=0&id=390d957a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390d957a",
  null
  
)

export default component.exports